import React from "react";
export var MainSearchBarSuggestionsContainer = React.memo(function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "py-2 shadow-xl rounded-[0.625rem] bg-white" },
        React.createElement("div", { className: "max-h-80 overflow-y-auto" }, children)));
});
